export const ActionTypes = {
    SET_PRODUCTS: "SET_PRODUCTS",
    SELECTED_PRODUCT: "SELECTED_PRODUCT",
    REMOVE_SELECTED_PRODUCT: "REMOVE_SELECTED_PRODUCT",
    SET_CATEGORY: "SET_CATEGORY",
    SET_CART: "SET_CART",
    ADD_CART: "ADD_CART",
  };